module.exports = __webpack_public_path__ + "static/media/howtofy_logo_black_RGB.eadb2d36.png";